export interface UserLevel {
  id: number;
  name: string;
}

export enum UserLevelNames {
  Admin = 1,
  Manager = 2,
  Sales = 3,
  Driver = 4,
}
